import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import test from './test'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app: app
    }
    /*state: {
        profileSelected: false
    },
    
    getters: {
        getProfileSelected: state => state.profileSelected
    },
    
    mutations: {
        setProfileSelected: (state, profile) => {
            state.profileSelected = profile
        }
    },
    
    actions: {
        setProfileSelected (context, profile) {
            context.commit('setProfileSelected', profile)
        }
    }*/
})

export default store